<template>
  <j-select-biz-component :width="1200" v-bind="configs" v-on="$listeners"/>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectEmLinkBidder',
    components: { JSelectBizComponent },
    props: ['value'],
    data() {
      return {
        settings: {
          name: '选择联合竞买人',
          displayKey: 'legalName',
          returnKeys: ['id','id','legalName'],
          listUrl: '/ebid-ce/emBidder/link/bidderSelect',
          queryParamCode: 'legalName',
          queryParamText: '竞买人名称',
          columns: [
            { title: '竞买人名称', dataIndex: 'legalName', align: 'center', width: '35%' },
            { title: '主体类别', dataIndex: 'bidderCodeType', align: 'center', width: '30%' },
            { title: '统一社会信用代码/身份证', dataIndex: 'legalCode', align: 'center', width: '25%' },
          ]
        }
      }
    },
    computed: {
      configs() {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    }
  }
</script>

<style lang="less" scoped></style>